<template>
  <sea-page title="Dettaglio documento" showCompanyHeader back>
    <doc-preview :data="doc" />
  </sea-page>
</template>

<script>
import { mapActions } from "vuex";
import DocPreview from "@/components/DocPreview.vue";

export default {
  components: {
    DocPreview,
  },
  beforeRouteEnter(to, _, next) {
    next((vm) => {
      vm.fetchDocumentById(to.query.id).then((res) => (vm.doc = res));
    });
  },
  data() {
    return {
      doc: null,
    };
  },
  methods: {
    ...mapActions({
      fetchDocumentById: "docsLav/fetchDocumentById",
    }),
  },
};
</script>

<style>
</style>